import { connect } from 'react-redux';
import { init, streamLoadMore, switchStream } from './redux/actionCreators';
import { getIsLoadingMore, getIsLoadingStream, getActiveStream } from './redux/selectors';
const mapStateToProps = (state)=>({
        activeStream: getActiveStream(state),
        isLoadingStream: getIsLoadingStream(state),
        isLoading: getIsLoadingMore(state)
    });
const mapDispatchToProps = {
    onInitialize: init,
    switchStream: switchStream,
    onLoadMore: streamLoadMore
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=EmoteSelector.container.js.map